// let baseURL="/api/workbenchlh";
import http from "@/utils/httpRequest";

// console.log(baseURL)
// 获取文件服务器路径
export const apifilePath = (params) => {
  return http.get("/filePath", { baseURL });
};

// 首页获取权限
export const apiIndex = (params) => {
  return http.get("/index", { baseURL });
};
// 中心审核获取待办事项分页-工程建设
export const apiAuditList = (params) => {
  return http.post("/auditList", { ...params }, { baseURL });
};

// 中心审核获取待办事项分页-协同办公
export const apiwbschedulemanagementlist = (params) => {
  return http.post("/wbschedulemanagement/list", { ...params }, { baseURL });
};
// 中心审核获取待办事项-协同办公-添加
export const apiwbschedulemanagementsave = (params) => {
  return http.post("/wbschedulemanagement/save", { ...params }, { baseURL });
};
// 中心审核获取待办事项-协同办公-查看
export const apiwbschedulemanagementget = (params) => {
  return http.get("/wbschedulemanagement/get?id=" + params, { baseURL });
};
// 中心审核获取待办事项-协同办公-完成
export const apiwbschedulemanagementupdateCompleteStatus = (params) => {
  return http.get("/wbschedulemanagement/updateCompleteStatus/" + params, {
    baseURL,
  });
};
// 中心审核获取待办事项-协同办公-上移下移
export const apiwbschedulemanagementmove = (params) => {
  return http.get(
    "/wbschedulemanagement/move?id=" + params.id + "&type=" + params.type,
    { baseURL }
  );
};
// 中心审核获取待办事项-协同办公-删除
export const apiwbschedulemanagementdelete = (params) => {
  return http.get(`/wbschedulemanagement/delete/${params}`, { baseURL });
};

// 获取项目跟踪列表
export const apiworkBenchIndexProjectProgress = (params) => {
  return http.post(
    `/workBenchIndex/projectProgress/${params.type}`,
    { ...params },
    { baseURL }
  );
};

// 审核角色获取今日开标数据
export const apiworkBenchIndexProjectIndex = (params) => {
  return http.post("/workBenchIndex/projectIndex", { ...params }, { baseURL });
};

// 获取待办事项的数据
export const apiAuditCount = (params) => {
  return http.post("auditCount", { ...params }, { baseURL });
};

// 工程建设获取项目类型
export const apiSysdatadictionaryGetDictionaryName = (params) => {
  return http.get(`/sysdatadictionary/getDictionaryName?type=${params}`, {
    baseURL,
  });
};

// 查询工程 采购 国土 产权 项目条数
export const apiworkBenchIndexcountPolymerization = (params) => {
  return http.post(
    `/workBenchIndex/countPolymerization`,
    { ...params },
    { baseURL }
  );
};

// 获取处理部门列表
export const apiworkBenchIndexgetRoleList = () => {
  return http.get(`workBenchIndex/getRoleList`, { baseURL });
};

// 开标项目获取地址
export const apijwtToBjm = (params) => {
  return http.get(
    `/jwtToBjm?bidId=${params.bidId}&openversion=${params.openversion}&systemType=${params.systemType}`,
    { baseURL }
  );
};

// 获取一周开评标场地
export const apijwtToField = (params) => {
  return http.get(`/jwtToField`, { baseURL });
};

// 获取待办地址-工程建设
export const apijwtToJsgc = (params) => {
  return http.post(`/jwtToJsgc`, { ...params }, { baseURL });
};
// 获取待办地址-政府采购
export const apijwtToZfcg = (params) => {
  return http.post(`/jwtToZfcg`, { ...params }, { baseURL });
};
// 获取今日开标和项目跟踪菜单条数统计
export const apiworkBenchIndexBidopenCount = (params) => {
  return http.post(
    `/workBenchIndex/bidopenCount/${params.type}`,
    { ...params },
    { baseURL }
  );
};

// 项目跟踪 工程建设更多
export const apijwtToJsgcProgress = (params) => {
  // return http.get(`/jwtToJsgcProgress?bidId=${params.bidId}&projectstate=${params.projectstate}&title=${params.title}`);
  return http.post(`/jwtToJsgcProgress`, { ...params }, { baseURL });
};
// 项目跟踪 政府采购更多
// export const apijwtToZfgcProgress=(params)=>{
// 	return http.post(`/jwtToZfgcProgress`,{...params},{baseURL});
// }

// 便捷入口-源列表入口获取列表
export const apiwbsystemconfiggetSystemConfigList = (params) => {
  return http.post(
    `/wbsystemconfig/getSystemConfigList`,
    { ...params },
    { baseURL }
  );
};

// 便捷入口获取常用系统列表
export const apiwbconveniententranceconvenientEntranceList = (params) => {
  return http.post(
    `/wbconveniententrance/convenientEntranceList`,
    { ...params },
    { baseURL }
  );
};

// 便捷入口删除某一数据-非自定义
export const apiwbconveniententrancedelete = (params) => {
  return http.post(`/wbconveniententrance/delete`, { ...params }, { baseURL });
};

// 便捷入口删除某一数据-自定义
export const apiwbconveniententrancedeleteCustomize = (params) => {
  return http.post(
    `/wbconveniententrance/deleteCustomize`,
    { ...params },
    { baseURL }
  );
};

// 便捷入口非自定义跳转
export const apijwtToSystem = (params) => {
  return http.get(`/jwtToSystem?id=${params}`, { baseURL });
};

// 便捷入口拖拽排序
export const apiwbconveniententrancesort = (params) => {
  return http.post(`/wbconveniententrance/sort`, params, { baseURL });
};

export const getMyProjectList = (params) => {
  return http.post("/tender/myProjectList", { ...params }, { baseURL });
};

export const getProjectList = (params) => {
  return http.post("/tender/myProjectList", { ...params }, { baseURL });
};
